import { withTranslation } from 'react-i18next';
import CatalogItem from './CatalogItem';

export default withTranslation()(CatalogItem);
